/* unplugin-vue-components disabled */import script from "./ParentsBind.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentsBind.vue?vue&type=script&setup=true&lang=js"

import "./ParentsBind.vue?vue&type=style&index=0&id=ce179ef4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce179ef4"]])

export default __exports__